import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { resendActivationCode as resendActivationCodeAction } from '../user-actions';
import { connect, useDispatch } from 'react-redux';
import Banner from '../../components/banner/Banner';
import styles from './activate-email-banner.module.less';
import ButtonText from '../../components/button/button-text/ButtonText';

const ActivateEmailBanner = ({ isSendingActivationCode = false, user, project = {} }) => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(resendActivationCodeAction(user));
        trackEvent('admin', 'banner-click', {
            'project-id': project.id,
            'banner-type': 'resend-activation',
        });
    };

    const bannerText =
        'For at du skal få full tilgang til Spleis så trenger vi å vite at du eier e-postadressen din. Bekreft dette ved å klikke på knappen i e-posten vi har sendt deg.';

    return (
        <Banner bannerText={bannerText} className={styles.banner}>
            <ButtonText disabled={isSendingActivationCode} className={styles.button} onClick={onClick}>
                {isSendingActivationCode ? 'Sender e-posten …' : 'Send e-posten på nytt'}
            </ButtonText>
        </Banner>
    );
};

const mapStateToProps = (state) => ({
    user: state.user,
    isSendingActivationCode: state.user.isSendingActivationCode,
});

export default connect(mapStateToProps)(ActivateEmailBanner);
